import { IDataRepo } from 'common/contracts';

export const ControlRoomRepo: IDataRepo[] = [
  {
    id: 'dataCenter/controlRoom/AutroSafe',
    label: 'AutroSafe',
    position: {
      top: 40,
      left: 22,
      unit: '%'
    }
  },
  {
    id: 'dataCenter/controlRoom/AutroMaster',
    label: 'AutroMaster',
    position: {
      top: 58,
      left: 64,
      unit: '%'
    }
  },
  {
    id: 'dataCenter/controlRoom/AutroGuard',
    label: 'AutroGuard',
    position: {
      top: 10,
      left: 50,
      unit: '%'
    }
  },
  {
    id: 'dataCenter/controlRoom/ManualCallPoint',
    label: 'Manual Call Point',
    position: {
      top: 55,
      left: 16,
      unit: '%'
    }
  }
];
